export class TrpmstbillDetail {
  public BILL_LOC!: string;
  public BILL_NO!: string;
  public BILL_CNNO!: string;
  public BILL_CNBASICFRT!: number;
  public BILL_CNDCCHARGE!: number;
  public BILL_CNGCCHARGE!: number;
  public BILL_CNDDCHARGE!: number;
  public BILL_CNOCCHARGE!: number;
  public BILL_CNTAMT!: number;
  public BILL_CNSTPER!: number;
  public BILL_CNST!: number;
  public BILL_TOT!: number;
  public BILL_FRTONPKG!: string;
  public BILL_UF!: number;
  public BILL_PKG!: number;
  public BILL_WT!: number;
  public BILL_DNCT!: string;
  public BILL_CNSPLVEHCHG!: number;
  public BILL_FOV!: number;
  public BILL_UNLOAD_CHARGE!: number;
  public BILL_TOLL_CHARGE!: number;
  public BILL_DETENTION_CHARGE!: number;
  public CREATEDBY_USERID!: Number;
  public UPDATEDBY_USERID!: Number;
  public CREATED_DATE!: string;
  public UPDATED_DATE!: string;
  public IS_ACTIVE!: boolean;
}
